function e(e,t){return e.filter((e=>Object.keys(e.names).some((r=>e.names[r].toUpperCase().includes(t.trim().toUpperCase())))))}export{e as filterCountries};
//# sourceMappingURL=countries.js.map
